import { createInvoiceContainer } from './container'
import { Invoice as InvoiceUI } from './ui/invoice'

const InvoiceContainer = createInvoiceContainer(InvoiceUI)

export const InvoiceDetailsPage = ({ id }: { id: string }) => {
  return <InvoiceContainer id={id} />
}
